import { ref, onMounted, onUnmounted } from 'vue';
import BlockGuard from './core.js';

export function useBlockGuard(options = {}) {
  const detected = ref(null);
  const reason   = ref(null);
  const checking = ref(true);
  let bg = null;

  onMounted(() => {
    bg = new BlockGuard({
      ...options,
      checkOnLoad: false,
      onResult: (det, rsn) => {
        detected.value = det;
        reason.value   = rsn;
        checking.value = false;
      },
    });
    bg.check();
  });

  onUnmounted(() => bg?.destroy());

  return { detected, reason, checking };
}

export { BlockGuard };
export default BlockGuard;
